import React from 'react';
import { BriefcaseIcon, HeartHandshakeIcon, TreesIcon, UserIcon } from 'lucide-react';
import { Seo } from '../components/ui/Seo';
import { PageHero } from '../components/ui/PageHero';
import { ButtonLink } from '../components/ui/ButtonLink';
import { SectionHeading } from '../components/ui/SectionHeading';
import { InquiryForm } from '../components/forms/InquiryForm';
import { IMAGES } from '../data/images';
import { SITE } from '../data/site';
const options = [{
  Icon: UserIcon,
  title: 'Private 1-on-1',
  body: 'Undivided attention from a lead instructor. Ideal for nervous beginners, specific skill goals or a tight schedule.'
}, {
  Icon: HeartHandshakeIcon,
  title: 'Couples & families',
  body: 'Learn together and build a shared home-defense plan your whole household understands.'
}, {
  Icon: BriefcaseIcon,
  title: 'Corporate',
  body: 'Safety and defensive awareness training for teams, security staff and executives.'
}, {
  Icon: TreesIcon,
  title: 'Organizations',
  body: 'Churches, clubs and community groups — including NDOW Hunter Safety education.'
}];
export function PrivateTraining() {
  return <>
      <Seo title="Private Firearms Training Las Vegas" description="Private 1-on-1, couples, corporate and organization firearms training in Las Vegas, including NDOW Hunter Safety." data-id="element-910" data-mp="nhymqhbger1q" />
      <PageHero title="Private & Group Training" sub="Built around you — your goals, your schedule, your pace. 7 days a week." image={IMAGES.hero} crumbs={[{
      label: 'Private Training'
    }]} data-id="element-911" data-mp="wg0sfa64u7vc">
        <ButtonLink href="#inquiry" size="lg" data-id="element-912" data-mp="166n6gzy7aqbx">
          Request Private Training
        </ButtonLink>
        <ButtonLink href={SITE.phoneHref} size="lg" variant="outline-light" data-id="element-913" data-mp="1k4k31wcnmwql">
          Call {SITE.phoneDisplay}
        </ButtonLink>
      </PageHero>

      <section className="gutter section bg-white" aria-labelledby="options-title" data-id="element-914" data-mp="3lx9blf7zbhqb">
        <SectionHeading id="options-title" title="Who we train privately" data-id="element-915" data-mp="3hwpf8dv8ci58" />
        <ul className="mt-12 grid gap-x-12 md:grid-cols-2 3xl:grid-cols-4" data-id="element-916" data-mp="3hysgju1u1xp9">
          {options.map(({
          Icon,
          title,
          body
        }) => <li key={title} className="flex gap-5 border-t border-navy/15 py-8" data-id="element-917" data-mp="1puczdy4gsiun">
              <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-navy" data-id="element-918" data-mp="1utzfcfbogd75">
                <Icon className="h-5 w-5 text-white" aria-hidden="true" data-id="element-919" data-mp="1zsstm9ysg88d" />
              </span>
              <div data-id="element-920" data-mp="23uxhes2k2an3">
                <h3 className="t-h3 text-navy" data-id="element-921" data-mp="23vflubzdfv63">{title}</h3>
                <p className="mt-2 max-w-[34rem] leading-relaxed text-steel" data-id="element-922" data-mp="23stf2ekb1jox">{body}</p>
              </div>
            </li>)}
        </ul>
      </section>

      <section id="inquiry" className="gutter section scroll-mt-24 grid gap-12 bg-mist lg:grid-cols-12" aria-labelledby="inquiry-title" data-id="element-923" data-mp="2dls41xjprc92">
        <div className="lg:col-span-4" data-id="element-924" data-mp="2ileho83geuie">
          <SectionHeading id="inquiry-title" title="Start your inquiry" intro="Private lessons from $125. Tell us what you need and we’ll reply within one business day." data-id="element-925" data-mp="2njg3v1w6f9y3" />
          <p className="mt-6 text-sm text-steel" data-id="element-926" data-mp="fwmzrr5kodwr">Note: training packages apply to group courses, not private sessions.</p>
        </div>
        <div className="lg:col-span-8" data-id="element-927" data-mp="bu8el0efl22b">
          <InquiryForm title="Private training request" topicLabel="Training type" topics={options.map(o => o.title)} showGroupSize submitLabel="Send Request" data-id="element-928" data-mp="bxe3ofn283y1" />
        </div>
      </section>
    </>;
}